export default "__VITE_ASSET__DyeuzYGn__"